import { addDatasetApiKey } from 'js/actions';
import { ResourceCard } from 'js/components/pipelines/cards/ResourceCard';
import { TMP_DISABLE_NEXSET_INSPECT } from 'js/constants/config';
import { ROUTE_REDESIGN, ROUTE_REUSABLE_TRANSFORMS } from 'js/constants/pathnames';
import { RESOURCE_TYPE_DATA_SET, RESOURCE_TYPE_RECORD_TRANSFORM } from 'js/constants/resourceTypes';
import useAppDispatch from 'js/hooks/useAppDispatch';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import flowTypes from 'new/components/flows/types/flowTypes';
import { TransformType } from 'new/components/ReusableTransform/types';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import useEntities from 'new/state/entities/repository/useEntities';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './DataCard.css';

function DataSetCard(props) {
  const { data, readOnly, adminAccess, owner, isLoading, metric, toggleUseExpanded } = props;

  const history = useHistory();
  const { data: flowNodes } = useEntities('flowNodes');
  const dispatch = useAppDispatch();

  useEffect(() => {
    const flowNode = flowNodes[data.origin_node_id];
    if (
      !data?.api_keys?.length &&
      flowNode?.linked_flows &&
      flowNode.linked_flows.some((flowId) => flowNodes[flowId]?.flow_type === flowTypes.genai_rag)
    ) {
      dispatch(addDatasetApiKey(data.id));
    }
  }, []);

  const errorCount =
    isLoading.metric === false && !isEmpty(metric) && has(metric.metric, 'errors')
      ? metric.metric.errors
      : null;
  const recordCount =
    isLoading.metric === false && !isEmpty(metric) && has(metric.metric, 'records')
      ? metric.metric.records
      : null;

  const status = data.status;

  const isClickable = Boolean(props?.onItemClick) ? ' clickable' : '';
  function onItemClick() {
    if (props?.onItemClick) {
      props.onItemClick(RESOURCE_TYPE_DATA_SET, data);
    }
  }

  function onEditTransform(transform, transformType = TransformType.ATTRIBUTE) {
    history.push(
      `${ROUTE_REDESIGN}${ROUTE_CONNECT}${ROUTE_REUSABLE_TRANSFORMS}?editId=${transform.id}&editType=${transformType}`,
    );
  }

  const InnerView = data.code_container_id ? (
    <ResourceCard
      data={{
        ...props.transforms[data.code_container_id],
        // Setting this so we know this is coming from a nexset before we do a request to fetch it
        data_sets: [data.id],
        resourceType: RESOURCE_TYPE_RECORD_TRANSFORM,
      }}
      resourceType={RESOURCE_TYPE_RECORD_TRANSFORM}
      onEditButtonClicked={onEditTransform}
      shouldUseResourceIcon
      status="normal"
      size="small"
      toggleUseExpanded={toggleUseExpanded}
    />
  ) : null;

  return (
    <ResourceCard
      {...props}
      InnerView={TMP_DISABLE_NEXSET_INSPECT ? null : InnerView}
      onClick={isClickable ? onItemClick : undefined}
      resourceType={RESOURCE_TYPE_DATA_SET}
      status="normal"
      toggleUseExpanded={toggleUseExpanded}
    />
  );
}

export default DataSetCard;
